var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24X7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 70,
    height: 69,
    rx: 10,
    fill: "#F0BA8E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 83,
    height: 84,
    rx: 7.5,
    stroke: "#100A55",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.1875 22.5H44.875C44.5103 22.5 44.1606 22.6449 43.9027 22.9027C43.6449 23.1606 43.5 23.5103 43.5 23.875V25.9375H27C24.7251 25.9375 22.875 27.7876 22.875 30.0625V54.125H19.4375V59.625C19.4375 63.4159 22.5216 66.5 26.3125 66.5H60.6875C64.4784 66.5 67.5625 63.4159 67.5625 59.625V54.125H64.125V39H66.1875C66.5522 39 66.9019 38.8551 67.1598 38.5973C67.4176 38.3394 67.5625 37.9897 67.5625 37.625V23.875C67.5625 23.5103 67.4176 23.1606 67.1598 22.9027C66.9019 22.6449 66.5522 22.5 66.1875 22.5ZM25.625 30.0625C25.625 29.3042 26.2417 28.6875 27 28.6875H43.5V37.625C43.5 37.9897 43.6449 38.3394 43.9027 38.5973C44.1606 38.8551 44.5103 39 44.875 39H46.9375V42.9284C46.9377 43.1829 47.0085 43.4324 47.142 43.6491C47.2756 43.8659 47.4667 44.0413 47.694 44.1558C47.9213 44.2704 48.1759 44.3197 48.4296 44.2981C48.6832 44.2766 48.9259 44.1851 49.1306 44.0339L55.9348 39H61.375V54.125H25.625V30.0625ZM64.8125 56.875V59.625C64.8125 61.8999 62.9624 63.75 60.6875 63.75H26.3125C24.0376 63.75 22.1875 61.8999 22.1875 59.625V56.875H64.8125ZM64.8125 36.25H55.4824C55.1882 36.25 54.9015 36.3449 54.6643 36.5195L49.6875 40.2011V37.625C49.6875 37.2603 49.5426 36.9106 49.2848 36.6527C49.0269 36.3949 48.6772 36.25 48.3125 36.25H46.25V25.25H64.8125V36.25Z",
    fill: "#100A55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28.6875H62.75V32.8125H60V28.6875ZM54.5 28.6875H57.25V32.8125H54.5V28.6875ZM49 28.6875H51.75V32.8125H49V28.6875Z",
    fill: "#100A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24X7);
export default __webpack_public_path__ + "static/media/24X7.de5ae512584edcd5d73b13b1c3c4d211.svg";
export { ForwardRef as ReactComponent };